<!-- TEMPLATE -->
<template>
  <div class="wrapper">
    <dean-dialog
        :title="titleItem"
        :small="true"
        :addClose="true"
        @close="close"
    >
      <slot name="load">

      </slot>
      <dean-notification :is-modal="true">

      </dean-notification>
      <date-input
          label="gewenste einddatum"
          placeholder="gewenste einddatum"
          :min-date="minimumDate"
          :disable-weekends="true"
          :disable-holidays="true"
          :value="data.date"
          :required-field="true"
          @dateValueChanged="wishDateValueChanged"
      ></date-input>
      <dean-form-row id="comment" label="opmerking" v-model="data.comment"></dean-form-row>

      <span slot="dean-dialog-button-group">
        <dean-button :danger="true" :dialog-button="true" @click.native="close()">Annuleren</dean-button>
        <dean-button :success="true" :dialog-button="true" @click.native="save()">Versturen</dean-button>
      </span>
    </dean-dialog>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
  import Vue from 'vue';
  import {Component, Prop} from 'vue-property-decorator';
  import {
    // SVG
    warningIcon,
    // COMPONENTS
    deanDialog,
    deanDialogButtonGroup,
  } from '@deanone/dean-components';
  import deanSelectFormRow from '@/components/deanComponents/deanSelectFormRow.vue';
  import deanButton from '@/components/deanComponents/deanButton.vue';
  import DeanNotification from '@/components/deanComponents/deanNotification.vue';
  import deanFormRow from '@/components/deanComponents/deanFormRow.vue';
  import {deanDialogBus} from '@/main';
  import {validationMixin} from 'vuelidate';
  import {required} from 'vuelidate/lib/validators';
  import {Validations} from 'vuelidate-property-decorators';
  import {createNotification} from '@/mixins/validations';
  import DateInput from '@/components/DateInput.vue';

  @Component({
    components: {
      warningIcon,
      DeanNotification,
      deanDialog,
      deanButton,
      deanFormRow,
      deanSelectFormRow,
      deanDialogButtonGroup,
      DateInput,
    },
    mixins: [validationMixin],
  })

  export default class OrderCancelOrderlineDialog extends Vue {
    // DATA
    @Prop() public payloadData!: {
      [key: string]: string,
    };
    public data: { [key: string]: any } = {
      date: '',
      comment: null,
    };
    public titleItem: string = 'Orderregel(s) opzeggen ';

    // COMPUTED
    @Validations()
    get validations() {
      return {
        data: {
          date: {required},
        },
      };
    }

    public wishDateValueChanged(data: string) {
      this.data.date = data;
    }

    get minimumDate(): Date {
      let minimumDate: Date;

      const currentDate: Date = new Date();
      currentDate.setMonth(currentDate.getMonth() + 1);

      minimumDate = currentDate;

      return minimumDate;
    }

    // METHODS
    public close() {
      deanDialogBus.$emit('close');
    }

    public save() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.$emit('setLoad', true);

        let requestAction: string;

        if (this.payloadData.mode === 'all') {
          requestAction = 'cancelAllOrderlines';
        } else {
          requestAction = 'cancelOrderline';
        }

        const requestData: any = {
          id: this.payloadData.data,
          data: this.data,
        };

        this.$store.dispatch(requestAction, requestData).then(
          (response) => {
            deanDialogBus.$emit('saved');
            this.$toast(this.$store.state.main.notification.messages.dataSaved);
            this.close();
          },
          (error) => {
            this.$toast({
              icon: warningIcon,
              text: 'Orderregels kunnen momenteel niet opgezegd worden',
              theme: 'warning',
            });
          },
        ).finally(() => {
          this.$emit('setLoad', false);
        });
      } else {
        this.$toast(createNotification(this.$v));
      }
    }

    public created() {
      this.$emit('setLoad', false);
    }
  }
</script>

<!-- STYLE -->
<style lang="scss" scoped>

:deep(.dialog .dean-dialog-container .dean-dialog-content .dean-dialog-slot) {
  overflow-y: visible;
}

</style>
